module.exports = __webpack_public_path__ + "static/media/how_zh_cn.f4ddffcf.vtt";